import { render, staticRenderFns } from "./floor-multi-sector.vue?vue&type=template&id=c2f88f96&scoped=true"
import script from "./floor-multi-sector.vue?vue&type=script&lang=js"
export * from "./floor-multi-sector.vue?vue&type=script&lang=js"
import style0 from "./floor-multi-sector.vue?vue&type=style&index=0&id=c2f88f96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2f88f96",
  null
  
)

export default component.exports